import Api from  "@/services/AxiosAPI";

export default {
  login(email, password) {

    const post = new FormData();
    post.append("email", email);
    post.append("password", password);

    return Api.postData('login', post)
      .then(responses => {
        return responses
      });


  },
  mycourses( user_id ) {
    return Api.getData('mycourses/' + user_id)
      .then(responses => {
        return responses
      });

  },
  getlink(link) {

    return Api.getData(link)
      .then(responses => {
        return responses
      });
  },
  delegate(userId) {
    let url = (userId) ? 'delegate-certificates/' + userId : 'delegate-certificates';
    return Api.getData(url)
      .then(responses => {
        return responses
      });

  },
  orderview(id) {
    return Api.getData('accounts/orderinfo/' + id)
      .then(responses => {
        return responses
      });
  },
  regsiter(email) {

    const post = new FormData();
    post.append("email", email);
    return Api.postData('user', post)
      .then(responses => {
        return responses
      });


  },
  orderhistory(customer_id) {
    let url = (customer_id) ? 'user-orders/' + customer_id : 'user-orders';
    return Api.getData(url)
      .then(responses => {
        return responses
      });

  },
  savedelegates(auth, customer_id, slug, traineeArray) {


    var myJSON = JSON.stringify(traineeArray);
    const post = new FormData();
    post.append("slug", slug);
    post.append("traineeArray", myJSON);
    return Api.postData('save-delegates/' + auth + '/' + customer_id, post)
      .then(responses => {
        return responses
      });


  },
  checkemail(email) {
    const post = new FormData();
    post.append("email", email);
    return Api.postData('checkuser', post)
      .then(responses => {
        return responses
      });
  },
  checkprice(cart) {
    var carts = JSON.stringify(cart);
    const post = new FormData();
    post.append("products", carts);
    return Api.postData('checkProductsPrice', post)
      .then(responses => {
        return responses.data
      });
  },
  forgot(email) {
    //var carts = JSON.stringify(cart);
    const post = new FormData();
    post.append("email", email);
    return Api.postData('requestpassword', post)
      .then(responses => {
        return responses.data
      });
  },
  resetpassword(resetpassword, token) {
    //var carts = JSON.stringify(cart);
    const post = new FormData();
    //post.append("userId", auth);
    post.append("passwordToken", token);
    post.append("newPassword", resetpassword.confirmPassword);
    return Api.postData('resetpassword', post)
      .then(responses => {
        return responses.data
      });
  },

  getuserdetails(customerid) {
    return Api.getData('users/' + customerid)
      .then(responses => {
        return responses.data
      });
  },
  gethcruserdetails(userid) {
    return Api.getData('hcr-user/' + userid)
      .then(responses => {
        return responses.data
      });
  },
  getdeliverydetails(customerid) {
    return Api.getData('consignee/' + customerid)
      .then(responses => {
        return responses.data
      });
  },
  changepassword(pass, auth) {
    const post = new FormData();
    post.append("currentPassword", pass.epassword);
    post.append("newPassword", pass.password);
    post.append("userId", auth);
    return Api.postData('changepassword', post)
      .then(responses => {
        return responses
      });

  },
  updatedelivery(data, auth) {
    return Api.postData('consignee', data)
      .then(responses => {
        return responses
      });

  },
  usercredits(auth, customer_id) {
    let url = (customer_id) ? 'user-credits/' + auth + '/' + customer_id :  'user-credits/' + auth;
    return Api.getData(url)
      .then(responses => {
        return responses
      });

  },
  usercreditsform(auth, customer_id, slug) {

    return Api.getData('user-credits-form/' + slug + '/' + auth + '/' + customer_id)
      .then(responses => {
        return responses
      });

  },
  updateDetails(user,userid) {
    return Api.postData('/user/'+userid, {'first_name':user.first_name,'first_name':user.first_name,
             'last_name':user.last_name,'address_1':user.address_1,'address_2':user.address_2,'address_3':user.address_3,
             'address_4':user.address_4,'town':user.town,'country_id':user.country_id,'postcode':user.postcode,'mobile_phone':user.mobile_phone,
             'phone':user.phone,'company_name':user.company_name,'county':user.county,'subscription':user.subscription,'courtesy_title':user.courtesy_title,
             'fax':user.fax
           })
               .then(response => {
                 return response.data
               });     
  },
  updateHcrDetails(user,userid) {
  return Api.postData('/hcr-user/'+userid, { 'name': (user.first_name+' '+user.last_name).trim() })
          .then(response => {
            return response.data
          });     
  },
  getcountry() {
    return Api.getData('country-list')
            .then(responses => {
            return responses
        });

  },
  downloadManualPDF(customer_id) {
    const post = new FormData();
    if(customer_id)
        post.append("user_id", customer_id);
    return Api.postData('download-pdf', post)
      .then(responses => {
        return responses
      });
  },

}